$(document).ready(function() {

  //===========================================================================
  // FILTERING ON THE COLLECTION PAGES
  //===========================================================================

  var CollectionFilter = {

    //=========================================================================

    init: function() {
      this.state = {
        $content: jQuery('.js-collection-content'),
        $footer: jQuery('.js-footer'),
        $filter: jQuery('.js-collection-filter'),
        topPadding: 50,
        prevScroll: 0
      };

      this.setTopPadding();
      this.setupEventListeners();
      this.updateSidebarOnScroll();
    },

    //=========================================================================

    setTopPadding: function() {
      if (jQuery('body').hasClass('sticky-header-adjust')) {
        this.state.topPadding = 146;
      }
    },

    //=========================================================================

    getOffsetTop: function(el) {
      var offsetTop = 0;
      var element = el;

      while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }

      return offsetTop;
    },

    //=========================================================================

    updateCollectionFilter: function() {
      this.updateSelectedTags();
      this.updateCollectionProducts();
    },

    //=========================================================================

    getUrlFilters: function() {
      var $checkboxes = jQuery('.js-collection-category-checkbox:checked');
      var filters = '';

      $checkboxes.each(function(i, el) {
        if (filters !== '') {
          filters += '+';
        }

        filters += jQuery(el).data('handle');
      });

      return filters;
    },

    //=========================================================================

    updateSelectedTags: function() {
      var $checkboxes = jQuery('.js-collection-category-checkbox:checked');
      var $tagsList   = jQuery('.js-collection-selected-tags');
      var $clearTags  = jQuery('.js-collection-clear-filter');
      var tags = ''
      var template;
      var $el;

      $checkboxes.each(function(i, el) {
        $el = jQuery(el);

        template = `<div class='b-collection-selected-tag js-collection-selected-tag' data-tag='${ $el.data('tag') }'>
          <span>${ $el.data('name') }</span>
          <span class='js-collection-selected-tag-close b-close-tag'>×</span>
        </div>`;

        tags += template;
      });

      if (!tags) {
        $clearTags.hide();
        $tagsList.hide();
      } else {
        $clearTags.css({ display: 'inline-block' });
        $tagsList.css({ display: 'inline-block' });
      }

      $tagsList.empty().html(tags);
    },

    //=========================================================================

    removeSelectedTag: function(e) {
      var $target = jQuery(e.currentTarget);
      var $tag = $target.closest('.js-collection-selected-tag');
      var tag = $tag.data('tag');

      jQuery(`.js-collection-selected-tag[data-tag="${ tag }"]`).remove();
      jQuery(`.js-collection-category-checkbox[data-tag="${ tag }"]`).prop( "checked", false ).trigger('change');
    },

    //=========================================================================

    clearSelectedTags: function(e) {
      var $checkboxes = jQuery('.js-collection-category-checkbox:checked');

      e.preventDefault();

      // jQuery('.js-collection-selected-tags').empty();
      $checkboxes.prop( "checked", false );
      this.updateCollectionFilter();
    },

    //=========================================================================

    scrollToGridTop: function() {
      var gridTop;

      if (window.innerWidth > 1000) {
        var gridTop = jQuery('.js-grid-header')[0] ? this.getOffsetTop(jQuery('.js-grid-header')[0]) : 0;

        jQuery('html').animate({ scrollTop: gridTop - this.state.topPadding }, "fast");
      }
    },

    //=========================================================================

    updateCollectionProducts: function() {
      var $collectionPage  = jQuery('.js-collection-page');
      var $collectionCount = jQuery('.js-collection-count');
      var $collectionGrid  = jQuery('.js-collection-grid');
      var $loading = jQuery('.js-collection-loading');
      var $btn = jQuery('.js-collection-load-more');
      var $btnWrapper = $btn.closest('.js-collection-load-more-wrapper');
      var filters  = this.getUrlFilters();
      var splitUrl = window.location.pathname.split('/collections/')[1] || '';
      var search   = window.location.search ? window.location.search.replace('?', '').split('&').filter(function(s) { return !s.match('page='); }).join('&') : '';
      var collectionName = splitUrl.split('/')[0];
      var url = `/collections/${ collectionName }/${ filters }?view=ajax${ search ? '&' + search : '' }`;
      var self = this;

      this.adjustContentHeightAtStartLoad();
      this.scrollToGridTop();
      $collectionCount.text('');
      $collectionGrid.empty();
      $btnWrapper.hide();
      $loading.fadeIn(800);

      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'html',
        success: function (data) {
          var $template = jQuery(data);
          var $collectionUpdate = $template.find('.js-collection-page-update');
          var products = $template.find('.js-collection-products').html() || '';
          var modals = $template.find('.js-quick-shop-modals').html() || '';
          var newCurrentPage = $collectionUpdate.data('current-page');
          var newTotalPages = $collectionUpdate.data('total-pages');
          var newCollectionCount = $collectionUpdate.data('collection-count');
          var shownProducts = $collectionUpdate.data('shown-products');

          $loading.fadeOut(800);
          $collectionGrid.empty().html(products);
          jQuery('.js-quick-shop-modals').empty().html(modals);
          self.reSetupQuickshopModals();

          $collectionPage.data('current-page', newCurrentPage);
          $collectionPage.data('total-pages', newTotalPages);
          $collectionPage.data('collection-count', newCollectionCount);
          $collectionPage.data('shown-products', shownProducts);

          if (newCollectionCount == 0) {
            $collectionCount.text('0');
          } else {
            $collectionCount.text(`${shownProducts} of ${newCollectionCount}`);
          }

          if (newCurrentPage >= newTotalPages) {
            $btnWrapper.hide();
            $btn.prop('disabled', true);
          } else {
            $btnWrapper.show();
            $btn.prop('disabled', false);
          }

          self.adjustContentHeightAtFinishLoad();
        },
        error: function(request, error) {
          console.log("Error: " + error);
        }
      });
    },

    //=========================================================================

    loadMore: function(e) {
      var $btn = jQuery(e.currentTarget);
      var $btnWrapper = $btn.closest('.js-collection-load-more-wrapper');
      var $collectionPage  = jQuery('.js-collection-page');
      var totalPages = $collectionPage.data('total-pages');
      var currentPage = $collectionPage.data('current-page');
      var nextPage = Number(currentPage) + 1;
      var filters = this.getUrlFilters();
      var splitUrl = window.location.pathname.split('/collections/')[1] || '';
      var search   = window.location.search ? window.location.search.replace('?', '').split('&').filter(function(s) { return !s.match('page='); }).join('&') : '';
      var collectionName = splitUrl.split('/')[0];
      var url = `/collections/${ collectionName }/${ filters }?page=${ nextPage }&view=ajax${ search ? '&' + search : '' }`;
      var self = this;

      if (nextPage <= Number(totalPages)) {
        $btn.prop('disabled', true);

        $.ajax({
          url: url,
          type: 'GET',
          dataType: 'html',
          success: function (data) {
            var $template = jQuery(data);
            var $collectionUpdate = $template.find('.js-collection-page-update');
            var products = $template.find('.js-collection-products').html() || '';
            var newModals = $template.find('.js-quick-shop-modals').html() || '';
            var newCurrentPage = $collectionUpdate.data('current-page');
            var newTotalPages = $collectionUpdate.data('total-pages');
            var newCollectionCount = $collectionUpdate.data('collection-count');
            var shownProducts = $collectionUpdate.data('shown-products');

            $('.js-quick-shop-modals .slick-slider').slick('unslick');
            jQuery('.js-collection-grid').append(products);
            jQuery('.js-quick-shop-modals').append(newModals);
            self.reSetupQuickshopModals();

            $collectionPage.data('current-page', newCurrentPage);
            $collectionPage.data('total-pages', newTotalPages);
            $collectionPage.data('collection-count', newCollectionCount);
            $collectionPage.data('shown-products', shownProducts);

            if (newCollectionCount == 0) {
              jQuery('.js-collection-count').text('0');
            } else {
              jQuery('.js-collection-count').text(`${shownProducts} of ${newCollectionCount}`);
            }

            if (newCurrentPage >= newTotalPages) {
              $btnWrapper.hide();
              $btn.prop('disabled', true);
            } else {
              $btnWrapper.show();
              $btn.prop('disabled', false);
            }
          },
          error: function(request, error) {
            console.log("Error: " + error);
          }
        });
      }
    },

    //=========================================================================

    reSetupQuickshopModals: function() {
      window.theme.reinitProductGridItem();
    },

    //=========================================================================

    toggleDropdown: function(e) {
      var $target  = jQuery(e.currentTarget);
      var $wrapper = $target.closest('.js-filter-dropdown');
      var $content = $wrapper.find('> .js-filter-dropdown-content');

      if ($target.hasClass('open')) {
        $target.removeClass('open');
        $content.slideUp(400);
      } else {
        $target.addClass('open');
        $content.slideDown(400);
      }
    },

    //=========================================================================

    closeDropdownFromFooterClick: function(e) {
      var $target  = jQuery(e.currentTarget);
      var $wrapper = $target.closest('.js-filter-dropdown');
      var $header  = $wrapper.find('> .js-filter-dropdown-header');
      var $content = $wrapper.find('> .js-filter-dropdown-content');

      $header.removeClass('open');
      $content.slideUp(400);
    },

    //=========================================================================

    adjustContentHeightAtStartLoad: function() {
      var $content = this.state.$content;
      var $inner   = $content.find('.js-collection-content-inner');
      var height   = $inner[0].offsetHeight;

      $content.css({ minHeight: height });
    },

    //=========================================================================

    adjustContentHeightAtFinishLoad: function() {
      var $content = this.state.$content;
      var $inner   = $content.find('.js-collection-content-inner');
      var height   = $inner[0].offsetHeight;

      $content.animate({ minHeight: height }, 1000);
    },

    //=========================================================================

    updateSidebarOnScroll: function() {
      var content = this.state.$content[0];
      var filter  = this.state.$filter[0];
      var footer  = this.state.$footer[0];

      if (window.innerWidth > 1000) {
        if (filter && filter.scrollHeight >= content.offsetHeight - 10) {
          this.state.$filter.removeClass('fixed-menu');
        } else if (content && content.getBoundingClientRect().top <= this.state.topPadding) {
          this.state.$filter.addClass('fixed-menu');

          if (footer && filter) {
            this.updateSidebarScroll();
          }

          this.state.prevScroll = content.getBoundingClientRect().top;
        } else if (content) {
          this.state.$filter.removeClass('fixed-menu');
          this.state.prevScroll = content.getBoundingClientRect().top;
        }
      }
    },

    //=========================================================================

    updateSidebarScroll: function() {
      var $content      = this.state.$content;
      var $sticky       = this.state.$filter;
      var hero          = $content[0];
      var bounds        = hero.getBoundingClientRect();
      var topPadding    = this.state.topPadding;
      var topScroll     = -bounds.top;
      var bottomScroll  = bounds.top + bounds.height - window.innerHeight;
      var topContentScroll    = $sticky[0].scrollTop - topPadding;
      var bottomContentScroll = $sticky[0].scrollHeight - $sticky[0].offsetHeight - $sticky[0].scrollTop;
      var isScrollingUp = this.state.prevScroll < bounds.top;
      var bottomOffset  = window.innerHeight - this.state.$footer[0].getBoundingClientRect().top;

      if (isScrollingUp && topScroll <= topContentScroll) {
        $sticky[0].scrollTop = -bounds.top + topPadding;
      } else if (!isScrollingUp && bottomScroll <= bottomContentScroll) {
        $sticky[0].scrollTop = $sticky[0].scrollHeight - $sticky[0].offsetHeight - bottomScroll;
      }

      if (bottomOffset && bottomOffset > 0) {
        $sticky.css({ top: '-' + bottomOffset + 'px' });
      } else {
        $sticky.css({ top: '0' });
      }
    },

    //=========================================================================

    setupEventListeners: function() {
      jQuery(document).on('change', '.js-collection-category-checkbox', this.updateCollectionFilter.bind(this));
      jQuery(document).on('click', '.js-collection-selected-tag-close', this.removeSelectedTag.bind(this));
      jQuery(document).on('click', '.js-collection-clear-filter', this.clearSelectedTags.bind(this));
      jQuery(document).on('click', '.js-collection-load-more', this.loadMore.bind(this));
      jQuery(document).on('click', '.js-filter-dropdown-header', this.toggleDropdown.bind(this));
      jQuery(document).on('click', '.js-filter-dropdown-footer', this.closeDropdownFromFooterClick.bind(this));
      jQuery(window).on('scroll', this.updateSidebarOnScroll.bind(this));
      jQuery(window).on('resize', this.updateSidebarOnScroll.bind(this));
    }
  };






  //===========================================================================
  // HORIZONTAL SLIDER.
  // See Collection Pages
  //===========================================================================

  var HorizontalSlider = {
    //=========================================================================

    init: function() {
      this.setupEventListeners();
    },

    //=========================================================================

    moveSlides: function(e) {
      var $target = jQuery(e.currentTarget);
      var $slider = $target.closest('.js-slider-wrapper').find('.js-slider');

      if ($target.hasClass('prev')) {
        this.moveSliderLeft($slider);
      } else if ($target.hasClass('next')) {
        this.moveSliderRight($slider);
      }
    },

    //=========================================================================

    moveSliderLeft: function($slider) {
      var sliderPos = $slider.scrollLeft();
      var cardWidth = $slider.find('.js-slider-item').width();
      var newPos    = cardWidth * (Math.round(sliderPos/cardWidth) - 1);

      if (newPos < 0) { newPos = 0; }

      $slider.animate({ scrollLeft: newPos }, "fast");
    },

    //=========================================================================

    moveSliderRight: function($slider) {
      var sliderPos = $slider.scrollLeft();
      var cardWidth = $slider.find('.js-slider-item').width();
      var newPos    = cardWidth * (Math.round(sliderPos/cardWidth) + 1);

      $slider.animate({ scrollLeft: newPos }, "fast");
    },

    //=========================================================================

    setupEventListeners: function() {
      jQuery(document).on('click', '.js-slider-arrow', this.moveSlides.bind(this));
    }
  };





  //===========================================================================
  // VERTICAL SLIDER.
  // Ex: PDP Desktop Thumbnails
  //===========================================================================

  var VerticalSlider = {
    //=========================================================================

    init: function() {
      this.setupEventListeners();
      this.updateVisibility();
    },

    //=========================================================================

    updateVisibility: function(e) {
      var $wrappers;
      var $wrapper;
      var $slides;

      if (e && e.isPdp) {
        $wrappers = jQuery('.js-pdp-wrapper').find('.js-vert-slider-wrapper');
      } else {
        $wrappers = jQuery('.js-vert-slider-wrapper');
      }

      $wrappers.each(function(i, wrapper) {
        $wrapper = jQuery(wrapper);
        $slides  = $wrapper.find('.js-vert-slider-item').not('.hide');


        if ($slides.length < 2) {
          $wrapper.addClass('no-scroll not-visible');
        } else if ($slides.length <= 5) {
          $wrapper.removeClass('not-visible');
          $wrapper.addClass('no-scroll');
        } else {
          $wrapper.removeClass('no-scroll not-visible');
        }
      });
    },

    //=========================================================================

    moveSlides: function(e) {
      var $target = jQuery(e.currentTarget);
      var $slider = $target.closest('.js-vert-slider-wrapper').find('.js-vert-slider');

      if ($target.hasClass('prev')) {
        this.moveSliderUp($slider);
      } else if ($target.hasClass('next')) {
        this.moveSliderDown($slider);
      }
    },

    //=========================================================================

    moveSliderUp: function($slider) {
      var sliderPos  = $slider.scrollTop();
      var card       = $slider.find('.js-vert-slider-item')[0];
      var cardHeight = card ? card.offsetHeight : 0;
      var newPos     = cardHeight * (Math.round(sliderPos/cardHeight) - 1);

      if (newPos < 0) { newPos = 0; }

      $slider.animate({ scrollTop: newPos }, "fast");
    },

    //=========================================================================

    moveSliderDown: function($slider) {
      var sliderPos  = $slider.scrollTop();
      var card       = $slider.find('.js-vert-slider-item')[0];
      var cardHeight = card ? card.offsetHeight : 0;
      var newPos     = cardHeight * (Math.round(sliderPos/cardHeight) + 1);

      $slider.animate({ scrollTop: newPos }, "fast");
    },

    //=========================================================================

    setupEventListeners: function() {
      jQuery(document).on('click', '.js-vert-slider-arrow', this.moveSlides.bind(this));
      jQuery(document).on('slideshowUpdate', this.updateVisibility.bind(this));
    }
  };






  //===========================================================================
  // ADDITIONAL FUNCTIONALITY FOR PRODUCT PAGE.
  // EXPANDS ON THE ORIGINAL SHOPIFY CODE.
  //===========================================================================

  var ProductV2 = {

    //=========================================================================

    init: function() {
      this.state = {
        $pdp: jQuery('.js-pdp-wrapper'),
        $pdpHero: jQuery('.js-pdp-header'),
        $pdpThumbnails: jQuery('.js-pdp-thumbnail-wrapper'),
        topPadding: 50,
        prevScroll: 0
      };

      this.setTopPadding();
      this.setupEventListeners();
      this.adjustPdpForProductViewCount();
      this.updateStickyHero();
      this.filterMobileSlideshow();
    },

    //=========================================================================

    setTopPadding: function() {
      if (jQuery('body').hasClass('sticky-header-adjust')) {
        this.state.topPadding = 146;
      }
    },

    // ========================================================================

    getProductData: function($parent) {
      var data = $parent.find('.js-product-data')[0];
      data = data ? JSON.parse(data.innerText) : null;

      return data;
    },

    //=========================================================================

    updateGridItemFromColorChange: function($target, value) {
      var $parent = $target.closest('.js-product-wrapper');
      var $image = $parent.find('.js-grid-product-image');
      var $link = $parent.find('.js-grid-product-link');
      var data = this.getProductData($parent);
      var variant;
      var i;

      if (data && data.variants) {
        for (i = 0; i < data.variants.length; i++) {
          variant = data.variants[i];

          if (variant.options.includes(value)) {
            if (variant.featured_image && variant.featured_image.src) {
              $image.css({ backgroundImage: `url(${ variant.featured_image.src })` });
            }

            if ($link[0] && $link[0].href && variant.id) {
              $link[0].href = `${ $link[0].href.split('?')[0] }?variant=${ variant.id }`;
            }

            break;
          }
        }
      }
    },

    //=========================================================================

    changeOptionLabel: function(e) {
      var $target  = jQuery(e.currentTarget);
      var $wrapper = $target.closest('.js-option-wrapper');
      var $label   = $wrapper.find('.js-option-label');
      var $checked = $wrapper.find('.js-option-change:checked');
      var value = $checked[0] ? $checked[0].value : '';

      if (value) {
        $label.text(value);
      }

      if ($target.hasClass('js-option-grid-color')) {
        this.updateGridItemFromColorChange($target, value);
      }
    },

    //=========================================================================

    adjustPdpForProductViewCount: function() {
      var $parent = jQuery('.js-repeat-view-section');
      var count = this.getPdpViewCount();
      var newCount = count + 1;

      if (!!window.location.pathname.match('/products/')) {
        this.setPdpViewCount(newCount);

        if ($parent[0] && newCount >= 3) {
          $parent.find('.js-repeat-view-initial-content').addClass('hide');
          $parent.find('.js-repeat-view-repeat-content').removeClass('hide');
        }

        $parent.find('.js-repeat-view-initial-content').removeClass('visually-invisible');
      }
    },

    //=========================================================================

    getPdpViewCount: function() {
      return Number(window.sessionStorage.getItem('Adore Adorn PDP Count')) || 0;
    },

    //=========================================================================

    setPdpViewCount: function(count) {
      window.sessionStorage.setItem('Adore Adorn PDP Count', count);
    },

    //=========================================================================

    toggleDropdown: function(e) {
      var $target   = jQuery(e.currentTarget);
      var $wrapper  = $target.closest('.js-dropdown-wrapper');
      var $dropdown = $wrapper.find('.js-dropdown-content');

      if ($target.hasClass('open')) {
        $target.removeClass('open');
        $dropdown.slideUp(400);
      } else {
        $target.addClass('open');
        $dropdown.slideDown(400);
      }
    },

    //=========================================================================

    toggleVideoPlay: function(e) {
      var $target = jQuery(e.currentTarget);
      var video = $target.find('video')[0];

      if ($target.hasClass('active')) {
        $target.removeClass('active');
        if (video) { video.pause(); }
      } else {
        $target.addClass('active');
        if (video) { video.play(); }
      }
    },

    //=========================================================================

    getOffsetTop: function(el) {
      var offsetTop = 0;
      var element = el;

      while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }

      return offsetTop;
    },

    //=========================================================================

    updateFromVariantChange: function(e) {
      var $modal  = jQuery('.modal--is-active');
      var $parent = $modal.length ? $modal : this.state.$pdp;
      var variant = e.variant;

      if (variant && variant.id) {
        $parent.find('.js-pdp-image').removeClass('active');
        $parent.find(`.js-pdp-image.js-variant-id-${ variant.id }`).addClass('active');

        if (!$modal.length && window.innerWidth > 1000) {
          this.adjustScrollerHeightAtVariantChange();
        }

        this.updateImagesForVariant($parent, variant);

        if (!$modal.length && window.innerWidth > 1000) {
          this.updateScrollerFromVariantChange(variant);
        }
      }
    },

    //=========================================================================

    filterSlideshowIfModal: function() {
      var tryModal = function(count) {
        var $modal = jQuery('.modal--is-active');
        var $slider = $modal.find('.js-product-slideshow-images.slick-slider');

        if (count > 0) {
          if ($slider[0]) {
            $slider.slick('slickFilter', ':not(.hide)');
          } else {
            setTimeout(function() {
              tryModal(count - 1);
            }, 200);
          }
        }
      };

      tryModal(5);
    },

    //=========================================================================

    filterMobileSlideshow: function() {
      var $slider = $('.js-product-slideshow-images.slick-slider');
      $slider.slick('slickFilter', ':not(.hide)');
    },

    //=========================================================================

    unfilterMobileSlideshow: function() {
      var $slider = $('.js-product-slideshow-images.slick-slider');
      $slider.slick('slickUnfilter');
    },

    //=========================================================================

    updateImagesForVariant: function($parent, variant) {
      var $images;
      var $image;
      var showImg;
      var data;

      if (variant && variant.options) {
        this.unfilterMobileSlideshow();
        $images = $parent.find('.js-pdp-image');

        $images.each(function(i, image) {
          $image = jQuery(image);
          data = $image.data('variant-options');

          if (!data || $image.hasClass('active')) {
            showImg = true;
          } else {
            showImg = variant.options.filter(function(option) {
              return data.split(',').includes(option);
            }).length;
          }

          if (showImg) {
            $image.removeClass('hide');
          } else {
            $image.addClass('hide');
          }
        });

        this.filterMobileSlideshow();
      }
    },

    //=========================================================================

    adjustScrollerHeightAtVariantChange: function() {
      var $pdp = this.state.$pdp;
      var $wrapper = $pdp.find('.js-pdp-images-wrapper');
      var $images  = $wrapper.find('.js-pdp-images');
      var height = $images[0].offsetHeight;

      $wrapper.css({ minHeight: height });

      setTimeout(function() {
        height = $images[0].offsetHeight;
        $wrapper.animate({ minHeight: height }, 1000);
      }, 1000);
    },

    //=========================================================================


    updateScrollerFromVariantChange: function(variant) {
      var $pdp  = this.state.$pdp;
      var $thumbnails = $pdp.find('.js-pdp-thumbnails');
      var image = $pdp.find(`.js-pdp-images .js-variant-id-${ variant.id }`)[0];
      var self = this;
      var top;

      if (image) {
        top = this.getOffsetTop(image);
        $thumbnails.addClass('freeze');

        $('html, body').animate(
          { scrollTop: top - 110 },
          {
            duration: "fast",
            complete: function() {
              $thumbnails.removeClass('freeze');
              self.scrollToActiveThumbnail();
            }
          }
        );
      }

      jQuery(document).trigger({
        type: 'slideshowUpdate',
        isPdp: true
      });
    },

    //=========================================================================

    updateScrollerFromThumbnail: function(e) {
      var $pdp    = this.state.$pdp;
      var $target = jQuery(e.currentTarget);
      var $thumbnails = $pdp.find('.js-pdp-thumbnails');
      var $images = $pdp.find('.js-pdp-images');
      var imageId = $target.data('id');
      var self = this;
      var $image;
      var image;
      var top;

      if (imageId && window.innerWidth > 1000) {
        $image = $images.find(`.js-pdp-image[data-id=${ imageId }]`);
        image  = $image[0];

        if (image) {
          $thumbnails.addClass('freeze');
          $pdp.find('.js-pdp-image').removeClass('active');
          $pdp.find(`.js-pdp-image[data-id=${ imageId }]`).addClass('active');
          top = this.getOffsetTop(image);
          $('html, body').animate(
            { scrollTop: top - 110 },
            {
              duration: "fast",
              complete: function() {
                $thumbnails.removeClass('freeze');
                self.scrollToActiveThumbnail();
              }
            }
          );
        }
      }
    },

    //=========================================================================

    updateFromScroll: function() {
      this.updateStickyHero();
      this.updateActiveThumbnailPosition();
    },

    //=========================================================================

    updateActiveThumbnailPosition: function() {
      var $pdp = this.state.$pdp;
      var $images = $pdp.find('.js-pdp-images-wrapper .js-pdp-image:not(.hide)');
      var self = this;
      var $image;
      var bounds;
      var imageId;

      $images.each(function(i, image) {
        bounds = image.getBoundingClientRect();

        if (bounds.top + (bounds.height / 2) > 0) {
          $image = jQuery(image);
          imageId = $image.data('id');

          if (!$image.hasClass('active')) {
            $pdp.find('.js-pdp-image').removeClass('active');
            $pdp.find(`.js-pdp-image[data-id=${ imageId }]`).addClass('active');

            self.scrollToActiveThumbnail();
          }

          return false;
        }
      });
    },

    //=========================================================================

    scrollToActiveThumbnail: function() {
      var $pdp = this.state.$pdp;
      var $thumbnails = $pdp.find('.js-pdp-thumbnails');
      var active = $thumbnails.find('.js-pdp-image.active')[0];

      if (!$thumbnails.hasClass('freeze') && active) {
        $thumbnails.animate({ scrollTop: active.offsetTop }, "fast");
      }
    },

    //=========================================================================

    updateStickyHero: function() {
      var $thumbnails = this.state.$pdpThumbnails;
      var $hero       = this.state.$pdpHero;
      var topPadding  = this.state.topPadding;
      var hero        = $hero ? $hero[0] : null;
      var height      = window.innerHeight;
      var $content;
      var $scroller;
      var $locked;
      var $free;
      var contentHeight;
      var scrollerHeight;
      var bounds;
      var top;

      if (hero && window.innerWidth > 1000) {
        bounds = hero.getBoundingClientRect();
        $content = $hero.find('.js-pdp-header-content');
        $scroller = $hero.find('.js-pdp-header-scroller');
        $contentInner = $content.find('.js-pdp-inner-content');
        $scrollerInner = $scroller.find('.js-pdp-inner-content');
        contentHeight = $contentInner[0] ? $contentInner[0].scrollHeight : 0;
        scrollerHeight = $scrollerInner[0] ? $scrollerInner[0].scrollHeight : 0;
        $locked = contentHeight <= scrollerHeight ? $content : $scroller;
        $free = contentHeight <= scrollerHeight ? $scroller : $content;

        if (scrollerHeight <= window.innerHeight) {
          $locked.removeClass('locked-fixed locked-bottom');
        } else if (bounds.top <= topPadding && (bounds.top + bounds.height) > height) {
          $locked.addClass('locked-fixed');
          $locked.removeClass('locked-bottom');
          $thumbnails.removeClass('locked-bottom');

          if ($locked && $locked[0]) {
            this.updateStickyHeroScroll($locked);
          }
        } else if (bounds.top <= topPadding && (bounds.top + bounds.height) <= height) {
          $locked[0].scrollTop = $locked[0].scrollHeight;
          $thumbnails.addClass('locked-bottom');
          $locked.addClass('locked-bottom');
          $locked.removeClass('locked-fixed');
        } else {
          $locked[0].scrollTop = 0;
          $thumbnails.removeClass('locked-bottom');
          $locked.removeClass('locked-fixed locked-bottom');
        }

        $free.removeClass('locked-fixed locked-bottom');
        this.state.prevScroll = bounds.top;
      }
    },

    //=========================================================================

    updateStickyHeroScroll: function($content) {
      var $hero  = this.state.$pdpHero;
      var hero   = $hero[0];
      var bounds = hero.getBoundingClientRect();
      var topPadding    = this.state.topPadding;
      var topScroll     = -bounds.top;
      var bottomScroll  = bounds.top + bounds.height - window.innerHeight;
      var topContentScroll    = $content[0].scrollTop - topPadding;
      var bottomContentScroll = $content[0].scrollHeight - $content[0].offsetHeight - $content[0].scrollTop;
      var isScrollingUp = this.state.prevScroll < bounds.top;

      if (isScrollingUp && topScroll <= topContentScroll) {
        $content[0].scrollTop = -bounds.top + topPadding;
      } else if (!isScrollingUp && bottomScroll <= bottomContentScroll) {
        $content[0].scrollTop = $content[0].scrollHeight - $content[0].offsetHeight - bottomScroll;
      }
    },

    //=========================================================================

    setupEventListeners: function() {
      jQuery(document).on('change', '.js-option-change', this.changeOptionLabel.bind(this));
      jQuery(document).on('click', '.js-dropdown-header', this.toggleDropdown.bind(this));
      jQuery(document).on('click', '.js-product-video-wrapper', this.toggleVideoPlay.bind(this));
      jQuery(document).on('click', '.js-pdp-thumbnails .js-pdp-image', this.updateScrollerFromThumbnail.bind(this));
      jQuery(document).on('variantChange', this.updateFromVariantChange.bind(this));
      jQuery(document).on('slideshowInitiated', this.filterSlideshowIfModal.bind(this));
      jQuery(window).on('scroll', this.updateFromScroll.bind(this));
      jQuery(window).on('resize', this.updateFromScroll.bind(this));
    }
  };





  //===========================================================================
  // INIT
  //===========================================================================

  Object.create(CollectionFilter).init();
  Object.create(HorizontalSlider).init();
  Object.create(VerticalSlider).init();
  Object.create(ProductV2).init();

});
